import type { Cookies } from "@packages/framework";

import { determineClientOrServer } from "../../utils/determineClientOrServer";
import { getSessionRefreshToken } from "./getSessionRefreshToken";
import { requestSessionRefresh } from "./requests/requestSessionRefresh";

export type GetSessionRequestHeadersProps = {
  valueToken?: string;
};

export const getSessionRequestHeaders = async ({
  valueToken,
}: GetSessionRequestHeadersProps): Promise<HeadersInit> => {
  if (valueToken) return { Authorization: `Bearer ${valueToken}` };

  let cookies: null | Cookies;

  if (determineClientOrServer() === "server") {
    const { getCookies } = await import("@packages/framework");
    cookies = await getCookies();
  }

  const { refreshToken } = getSessionRefreshToken({ cookies });
  const { access_token: token } = await requestSessionRefresh({ refreshToken });
  return { Authorization: `Bearer ${token}` };
};
